"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTooltip = void 0;
const react_1 = __importDefault(require("react"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const fa_1 = require("react-icons/fa");
const FTooltip = ({ className = "", id = "", display = "inline-block", place = "top", effect = "solid", textColor = "", backgroundColor = "", offset, event, align = "none", icon = react_1.default.createElement(fa_1.FaInfo, null), text = "Place your text here...", children, }) => {
    return (react_1.default.createElement("div", { className: `f-tooltip float-${align} d-${display} ${className}` },
        react_1.default.createElement("a", { "data-tip": true, "data-for": id }, text && text !== "Place your text here..." ? text : icon),
        react_1.default.createElement(react_tooltip_1.default, { place: place, effect: effect, event: event, offset: offset, textColor: textColor, backgroundColor: backgroundColor, id: id },
            react_1.default.createElement("span", null,
                icon && !children ? children : children,
                " "))));
};
exports.FTooltip = FTooltip;
//# sourceMappingURL=Ftooltip.js.map